// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './auth'
import users from '@src/views/apps/user/store'
import customerUsers from '@src/views/apps/user/store/customer'
import bookings from '@src/views/apps/operations/booking/store'
import products from '@src/views/apps/operations/product/store'
import services from '@src/views/apps/operations/service/store'
import businesses from '@src/views/apps/business/businesses/store'
import roles from '@src/views/apps/roles-permissions/store'
import deeplinks from '@src/views/apps/operations/deeplink/store'
import businessPolicies from '@src/views/apps/business/policies/store'
import tickets from '@src/views/apps/support/tickets/store'
import errorLogs from '@src/views/apps/system/error-logs/store'
import contentModeration from '@src/views/apps/content-moderation/store'
import educationalContent from '@src/views/apps/content/educational/store'
import promotionalContent from '@src/views/apps/content/featured/store'
import legalPages from '@src/views/apps/content/legal/store'
import faq from '@src/views/apps/content/faq/store'
import featureToggles from '@src/views/apps/system/feature-toggles/store'
import dynamicForms from '@src/views/apps/form-workflow/store'
import feedback from '@src/views/apps/support/feedback/store'
import notificationTemplates from '@src/views/apps/platform-configuration/notification-templates/store'
import appNotifications from '@src/views/apps/platform-configuration/app-notifications/store'
import transactions from '@src/views/apps/financial/transactions/store'
import refunds from '@src/views/apps/financial/refunds/store'
import returns from '@src/views/apps/financial/returns/store'
import payouts from '@src/views/apps/financial/payouts/store'
import invoices from '@src/views/apps/financial/invoices/store'
import cancellationPolicies from '@src/views/apps/financial/cancellation-policies/store'
import analyticsDashboard from '@src/views/apps/analytics-reporting/dashboard/store'

const rootReducer = {
  auth,
  users,
  customerUsers,
  bookings,
  products,
  services,
  businesses,
  navbar,
  layout,
  roles,
  deeplinks,
  businessPolicies,
  tickets,
  errorLogs,
  contentModeration,
  educationalContent,
  promotionalContent,
  legalPages,
  faq,
  featureToggles,
  dynamicForms,
  feedback,
  notificationTemplates,
  appNotifications,
  transactions,
  refunds,
  returns,
  payouts,
  invoices,
  cancellationPolicies,
  analyticsDashboard,
}

export default rootReducer
